import Profil from './Profil';

export default Profil;
